import React, { Component } from 'react'
import classnames from 'classnames'
import { Col, Row } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { withStyles } from '@material-ui/core/styles'
import RBButton from '../RBButton'
import { localize } from '../../util/Localizer'
import {
  IconDentist,
  IconDrug
} from '../../assets/images'
import { ClaimTypes } from '../../redux/SubmitClaim/Common'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import { injectIntl } from 'react-intl'
import styles from './styles'
import Config from '../../Config'

const getClaimButtonTitle = function (selectedType = '', props = {}) {
  if (Array.isArray(props.extendedHealthCareTypes)) {
    const found = props.extendedHealthCareTypes.find(t => (t.nameEnglish === selectedType))
    return (found) ? found.name : props.name
  } else {
    return props.name
  }
}

class ClaimTypeButton extends Component {
  constructor (props) {
    super(props)

    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.getEmptyState = this.getEmptyState.bind(this)
    this.returnTypeFeild = this.returnTypeFeild.bind(this)
    this.getExpenseServiceItems = this.getExpenseServiceItems.bind(this)

    const { props: innerProps = {}, selected = {} } = props

    this.state = {
      categoryCode: null,
      serviceItems: [],
      selected: null,
      open: false,
      title: getClaimButtonTitle(selected.type, innerProps)
    }
  }

  componentDidMount () {
    if (this.props.selected) {
      const {
        categoryCode,
        type,
        serviceItems = []
      } = this.props.selected

      if (categoryCode && type && type !== ClaimTypes.UNKNOWN) {
        this.setState({
          categoryCode,
          selected: type,
          title: getClaimButtonTitle(type, this.props.props),
          serviceItems
        })
      }
    }
  }

  handleOpen () {
    this.setState({ open: true })
  }

  handleClose () {
    this.setState({ open: true })
  }

  getExpenseServiceItems (e, categtoryCode) {
    let coverage = this.props.props.extendedHealthCareTypes.find((t) => t.categoryCode === categtoryCode)
    if (!coverage) {
      return
    }

    this.setState({
      serviceItems: coverage.serviceItems || [],
      selected: coverage.name,
      categoryCode: coverage.categoryCode,
      title: getClaimButtonTitle(coverage.nameEnglish, this.props.props)
    }, () => {
      this.props.onClick(coverage)
    })
  }

  returnTypeFeild (types) {
    const { classes = {} } = this.props
    const { categoryCode = '' } = this.state
    const { wlKey } = Config
    return (
      <div>
        <Row>
          <Col className={classes.radioColumn}>
            <RadioGroup name='benefit' onChange={(e, b) => this.getExpenseServiceItems(e, b)} value={this.state.categoryCode} >
              {types.map((b, i) => {
                if (b.categoryCode !== '') {
                  return (
                    <FormControlLabel
                      key={i}
                      value={b.categoryCode}
                      control={<Radio className={classes.baseRadioButton} color="primary" />}
                      label={b.name}
                      labelPlacement="end"
                    />
                  )
                } else return null
              })}
              {types.map((b, i) => {
                if (b.categoryCode === '') {
                  return (
                    <FormControlLabel
                      key={i}
                      value={b.categoryCode}
                      control={<Radio className={classes.baseRadioButton} color="primary" />}
                      label={b.name}
                      labelPlacement="end"
                    />
                  )
                } else return null
              })}
            </RadioGroup>
          </Col>
          <Col className={classes.expensesCovered}>
            {(this.state.categoryCode === null) && (
              <div>
                <h4 className={classes.expensesCoveredTitle}>{localize('pages.SubmitAClaim.Expenses.covered')}</h4>
                <div className={classes.emptyStateContainer}>
                  <i className={classnames('fa fa-user-md', classes.emptyStateIcon)} aria-hidden='true' />
                  <p>{localize('pages.SubmitAClaim.NewClaim.noServiceType')}</p>
                </div>
              </div>
            )}
            {(this.state.categoryCode !== null) && this.state.serviceItems.length > 0 && (
              <React.Fragment>
                <h4 className={classes.expensesCoveredTitle}>{localize('pages.SubmitAClaim.Expenses.covered')}</h4>
                {categoryCode === '' && wlKey === 'iuoe' && <p>{localize('pages.SubmitAClaim.NewClaim.serviceTypeText')}</p>}
              </React.Fragment>
            )}
            {(this.state.categoryCode !== null) && this.state.serviceItems.length > 0 && (
              <ul className={classes.ul}>
                {this.state.serviceItems.map((t, k) => {
                  return <li key={k} className={classes.li}>{t.name}</li>
                })}
              </ul>
            )}
          </Col>
        </Row>
        <p className={classes.serviceNote}>
          {localize('pages.SubmitAClaim.noBenefitType')}
          <a onClick={() => this.getEmptyState('general')}><span className={classes.embeddedLinkStyles}> {localize('pages.SubmitAClaim.submitAnImage')} </span></a>
          {localize('pages.SubmitAClaim.NewClaim.Or')}
          <a onClick={() => this.getEmptyState('general')}><span className={classes.embeddedLinkStyles}> {localize('pages.SubmitAClaim.mailReceipt')} </span></a>
        </p>
        <Row end="xs">
          <Col xs={4}>
            <RBButton
              id='addClaimExpenseBtn'
              className={ classnames(classes.button) }
              label={localize('common.okay')}
              disabled={!this.state.selected}
              onClick={() => this.setState({ open: false })}
              primary
              variant='contained'
            />
          </Col>
        </Row>
      </div>
    )
  }

  getEmptyState (coverage) {
    // NOTE: when it's dental the props come in as {name, nameEnglish} and nameEnglish is required in ClaimTypeBenefitSelect
    // to make a call to redux
    this.setState({ selected: coverage }, () => {
      this.props.onClick(coverage)
      this.setState({ open: false })
    })
  }

  returnIcon (selected) {
    const props = this.props.props
    if (ClaimTypes.isDental(props.name)) {
      return (
        <div alt={props.name} className='benefitIconSvg'>
          <IconDentist altcolor={selected === 'claimTypeSelected'} />
        </div>
      )
    } else if (ClaimTypes.isDrug(props.name)) {
      return (
        <div alt={props.name} className='benefitIconSvg'>
          <IconDrug altcolor={selected === 'claimTypeSelected'} />
        </div>
      )
    } else {
      return (
        <i className='fa fa-user-md fontIcon' aria-hidden='true' />
      )
    }
  }

  returnSelectedClass () {
    const props = this.props.props
    let className = 'claimTypeUnSelect'

    if (props.extendedHealthCareTypes) {
      if (this.state.selected && (this.state.selected !== props.name) && (!ClaimTypes.isDental(this.props.primary)) && (!ClaimTypes.isDrug(this.props.primary))) {
        className = 'claimTypeSelected'
      } else {
        className = 'claimTypeUnSelect'
      }
    } else {
      if (this.props.primary === props.nameEnglish) {
        className = 'claimTypeSelected'
      } else {
        className = 'claimTypeUnSelect'
      }
    }

    return className
  }

  render () {
    const { classes = {} } = this.props
    let props = this.props.props

    if (this.props) {
      let selected = this.returnSelectedClass()
      return (
        <div>
          <Paper className={selected} onClick={props.extendedHealthCareTypes || ClaimTypes.isDental(props.name) ? () => this.handleOpen() : () => this.props.onClick(props || props.name)}>
            {this.returnIcon(selected)}
            <h4>{this.state.title}</h4>
          </Paper>
          {props.extendedHealthCareTypes
            ? <Dialog
              open={this.state.open}
              onClose={() => {
                this.setState({
                  selected: null,
                  categoryCode: null,
                  open: false
                })
              }}
              maxWidth='md'

              disableBackdropClick={true}
              disableEscapeKeyDown={true}
            >
              <DialogTitle>{localize('pages.SubmitAClaim.NewClaim.selectYourCoverage')}</DialogTitle>
              <DialogContent >
                {this.returnTypeFeild(props.extendedHealthCareTypes)}
              </DialogContent>
            </Dialog>
            : null
          }
          {ClaimTypes.isDental(props.name)
            ? <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              disableBackdropClick={true}
              disableEscapeKeyDown={true}
            >
              <DialogTitle className={classes.dentalTitle}>{localize('pages.SubmitAClaim.claimingDentalAccident')}</DialogTitle>
              <DialogContent>
                <Row center='xs' middle='xs'>
                  <Col>
                    <RadioGroup name='accident' onChange={(e, val) => this.getEmptyState(val)} className={classes.dentalRadioButtonGroup}>
                      <FormControlLabel
                        value='dentalAccident'
                        control={<Radio className={ classnames(classes.baseRadioButton, classes.dentalRadioButton) } color="primary" />}
                        label={localize('yesText')}
                      />
                      <FormControlLabel
                        value={props.nameEnglish}
                        control={<Radio className={ classnames(classes.baseRadioButton, classes.dentalRadioButton) } color="primary" />}
                        label={localize('noText')}
                      />
                    </RadioGroup>
                  </Col>
                </Row>
              </DialogContent>
            </Dialog>
            : null
          }
        </div>
      )
    }
  }
}

export default withStyles(styles)(injectIntl(ClaimTypeButton))



// WEBPACK FOOTER //
// ./src/controls/claimTypeButton/index.js